import * as Actions from '../../actions';

const initialState = { data: null };

const listDriverReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_DRIVER_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        case Actions.GET_HAULING_DRIVER_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listDriverReducer;
